import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { compact } from 'lodash-es';
export var ContactIntegrationType = /*#__PURE__*/ function(ContactIntegrationType) {
    ContactIntegrationType["Qbo"] = "qbo";
    ContactIntegrationType["Xero"] = "xero";
    return ContactIntegrationType;
}({});
export class ContactIntegrationsModel {
    static fromDTO(contactIntegrations) {
        if (!contactIntegrations) return new ContactIntegrationsModel({});
        let qbo = undefined;
        let xero = undefined;
        contactIntegrations.forEach((integration)=>{
            if (integration.type === "qbo") {
                qbo = QboContactIntegrationModel.fromDTO(integration);
            } else if (integration.type === "xero") {
                xero = XeroContactIntegrationModel.fromDTO(integration);
            }
        });
        return new ContactIntegrationsModel({
            qbo,
            xero
        });
    }
    static toDTO(contactIntegrations) {
        var _contactIntegrations_qbo, _contactIntegrations_xero;
        const qboIntegrations = (_contactIntegrations_qbo = contactIntegrations.qbo) === null || _contactIntegrations_qbo === void 0 ? void 0 : _contactIntegrations_qbo.toJSON();
        const xeroIntegrations = (_contactIntegrations_xero = contactIntegrations.xero) === null || _contactIntegrations_xero === void 0 ? void 0 : _contactIntegrations_xero.toJSON();
        return [
            ...Array.isArray(qboIntegrations) ? qboIntegrations : [
                qboIntegrations
            ],
            ...Array.isArray(xeroIntegrations) ? xeroIntegrations : [
                xeroIntegrations
            ]
        ].filter((integration)=>integration != null);
    }
    toJSON() {
        var _this_qbo, _this_xero;
        const json = compact([
            (_this_qbo = this.qbo) === null || _this_qbo === void 0 ? void 0 : _this_qbo.toJSON(),
            (_this_xero = this.xero) === null || _this_xero === void 0 ? void 0 : _this_xero.toJSON()
        ]);
        return json.length ? json : undefined;
    }
    hasIntegrations() {
        return !!(this.qbo || this.xero);
    }
    xeroIntegratedId() {
        return this.xero ? this.xero.integratedId() : null;
    }
    qboIntegratedId() {
        return this.qbo ? this.qbo.integratedId() : null;
    }
    setQboIntegratedId(integratedId) {
        const qbo = this.qbo ? this.qbo.setIntegratedId(integratedId) : integratedId != null ? new QboContactIntegrationModel(integratedId) : undefined;
        return this.cloneWithChanges({
            qbo
        });
    }
    setXeroIntegratedId(integratedId) {
        const xero = this.xero ? this.xero.setIntegratedId(integratedId) : integratedId != null ? new XeroContactIntegrationModel(integratedId) : undefined;
        return this.cloneWithChanges({
            xero
        });
    }
    cloneWithChanges() {
        let changes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return new ContactIntegrationsModel({
            qbo: 'qbo' in changes ? changes.qbo : this.qbo,
            xero: 'xero' in changes ? changes.xero : this.xero
        });
    }
    constructor(data){
        _define_property(this, "qbo", void 0);
        _define_property(this, "xero", void 0);
        this.qbo = data.qbo;
        this.xero = data.xero;
    }
}
export class XeroContactIntegrationModel {
    static fromDTO(dto) {
        return new XeroContactIntegrationModel(dto.value.integratedId);
    }
    toJSON() {
        return {
            type: "xero",
            value: {
                integratedId: this._integratedId
            }
        };
    }
    integratedId() {
        return this._integratedId;
    }
    setIntegratedId(integratedId) {
        return new XeroContactIntegrationModel(integratedId || null);
    }
    constructor(_integratedId){
        _define_property(this, "_integratedId", void 0);
        this._integratedId = _integratedId;
    }
}
export class QboContactIntegrationModel {
    static fromDTO(dto) {
        return new QboContactIntegrationModel(dto.value.integratedId);
    }
    toJSON() {
        return {
            type: "qbo",
            value: {
                integratedId: this._integratedId
            }
        };
    }
    integratedId() {
        return this._integratedId;
    }
    setIntegratedId(integratedId) {
        return new QboContactIntegrationModel(integratedId || null);
    }
    constructor(_integratedId){
        _define_property(this, "_integratedId", void 0);
        this._integratedId = _integratedId;
    }
}
